export const nssRoutes = [
  { key: 'SSSS', route: '/new-suite-search/search' },
  { key: 'SSCR', route: '/new-suite-search/customer-review' }
];
